import { createBrowserRouter } from 'react-router-dom';
import { AUTH, PRIVATE, PUBLIC } from 'router/routes';
import { withSuspense } from 'router/suspense';

export const router = createBrowserRouter([
  {
    path: AUTH.ROOT.path,
    element: withSuspense(AUTH.ROOT.element),
    children: [
      {
        path: AUTH.EMAIL.path,
        element: withSuspense(AUTH.EMAIL.element),
      },
      {
        path: AUTH.TWO_FACTOR.path,
        element: withSuspense(AUTH.TWO_FACTOR.element),
      },
    ],
  },
  {
    path: PRIVATE.ROOT.path,
    element: withSuspense(PRIVATE.ROOT.element),
    children: [
      {
        path: '',
        element: withSuspense(PRIVATE[404].element),
      },

      {
        path: PRIVATE.APPLICATION.path,
        element: withSuspense(PRIVATE.APPLICATION.element),
      },
      {
        path: PRIVATE.PAIRS.path,
        element: withSuspense(PRIVATE.PAIRS.element),
      },
      {
        path: PRIVATE.BACKTESTS.path,
        element: withSuspense(PRIVATE.BACKTESTS.element),
      },
      {
        path: PRIVATE.STRATEGIES.path,
        element: withSuspense(PRIVATE.STRATEGIES.element),
      },
      {
        path: PRIVATE.STRATEGY.path,
        element: withSuspense(PRIVATE.STRATEGY.element),
      },
      {
        path: PRIVATE.CANDLE_WORKERS.path,
        element: withSuspense(PRIVATE.CANDLE_WORKERS.element),
      },
      {
        path: PRIVATE.CANDLE_VALIDATIONS.path,
        element: withSuspense(PRIVATE.CANDLE_VALIDATIONS.element),
      },
      {
        path: PRIVATE.PAIR.path,
        element: withSuspense(PRIVATE.PAIR.element),
      },
      {
        path: PRIVATE[404].path,
        element: withSuspense(PRIVATE[404].element),
      },
    ],
  },
  {
    path: PUBLIC.ROOT.path,
    element: withSuspense(PUBLIC.ROOT.element),
    children: [
      {
        path: PUBLIC.FRAMEWORK.path,
        element: withSuspense(PUBLIC.FRAMEWORK.element),
      },
      {
        path: PUBLIC.BUTTONS.path,
        element: withSuspense(PUBLIC.BUTTONS.element),
      },
      {
        path: PUBLIC.SELECTS.path,
        element: withSuspense(PUBLIC.SELECTS.element),
      },
      {
        path: PUBLIC.CALENDAR.path,
        element: withSuspense(PUBLIC.CALENDAR.element),
      },
      {
        path: PUBLIC.CHIPS.path,
        element: withSuspense(PUBLIC.CHIPS.element),
      },
      {
        path: PUBLIC.LOGIN.path,
        element: withSuspense(PUBLIC.LOGIN.element),
      },
      {
        path: PUBLIC.CREATE_ACCOUNT.path,
        element: withSuspense(PUBLIC.CREATE_ACCOUNT.element),
      },
      {
        path: PUBLIC.PASSWORD_REQUEST.path,
        element: withSuspense(PUBLIC.PASSWORD_REQUEST.element),
      },
      {
        path: PUBLIC.PASSWORD_RESET.path,
        element: withSuspense(PUBLIC.PASSWORD_RESET.element),
      },
    ],
  },
]);
